module.exports = __webpack_public_path__ + "img/question.961f4a95.svg";